import React from 'react';
import { Outlet } from 'react-router-dom';
import type { NavItem } from '../components/AdminSideNav';
import AdminSideNav from '../components/AdminSideNav';
import { ROUTES } from '../constants';
import { useTranslation } from '../contexts/TranslationContext';

const AdminPanel: React.FC = () => {
  const { t } = useTranslation();
  const navItems: NavItem[] = [
    {
      label: t.admin.users,
      route: ROUTES.ADMIN_USERS,
    },
    {
      label: t.admin.sportIcons,
      route: ROUTES.ADMIN_SPORT_ICONS,
    },
    {
      label: t.admin.leagues,
      route: ROUTES.ADMIN_LEAGUES,
    },
    {
      label: t.admin.philipSnatRunners,
      route: ROUTES.ADMIN_PHILIP_SNAT_RUNNERS,
    },
  ];

  return (
    <div className="admin-panel">
      <div className="admin-panel__container">
        <AdminSideNav title={t.admin.admin} items={navItems} />
        <main className="admin-panel__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;
